// extracted by mini-css-extract-plugin
export var section = "styles-module--section--d9186";